












































import { Size } from '@front-app/components/constants';
import { defineComponent } from '@vue/composition-api';
import TrForm from '@front-app/components/form/Form.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';

export default defineComponent({
	components: {
		TrForm,
		CtaButton,
		ErrorCard,
		SuccessCard,
	},
	props: {
		header: {
			type: String,
			required: true,
		},
		isLoading: Boolean,
		isError: Boolean,
		isSuccess: Boolean,
		errorMessage: {
			type: String,
			default: '',
		},
	},
	setup() {
		return {
			Size,
			ButtonPalettes,
		};
	},
});
